// extracted by mini-css-extract-plugin
module.exports = {"accountNavButton":"yX","menuBackground":"yY","navArrow":"yZ","avatar":"y0","userName":"y1","active":"y2","b":"y3","a":"y4"};